import {Component, Input} from '@angular/core';
import {GeneralDescriptionCardRowInfo} from '../general-description-card-info';

@Component({
  selector: 'app-general-description-card-info-item',
  templateUrl: './general-description-card-info-item.component.html',
  styleUrls: ['../general-description-card-info.component.scss']
})
export class GeneralDescriptionCardInfoItemComponent {
  @Input() item: GeneralDescriptionCardRowInfo;
}
